import { isRejectedWithValue } from '@reduxjs/toolkit';

// ** Third Party
import { toast } from 'react-toastify';

// ** utils imports
import SessionStorage from '../../../utils/SessionStorage';

export const ErrorHandler = api => next => action => {
  if (isRejectedWithValue(action)) {
    if (action.payload.status === 401) {
      SessionStorage.remove('user');
      SessionStorage.remove('token');

      window.location.reload(true);
    }

    if (action && action.payload.data && action.payload.data.message) {
      toast.error(action.payload.data.message || 'Something went wrong!');
    } else {
      toast.error(action.payload.error || 'Something went wrong!');
    }
  }

  return next(action);
};
